import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { supabase } from '../../integrations/supabase/client';

const { FiUploadCloud, FiCheck, FiX, FiLoader } = FiIcons;

const ImageUpload = ({ onUploadComplete, currentImage }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileChange = async (e) => {
    try {
      setUploading(true);
      setError(null);
      const file = e.target.files[0];
      
      if (!file) return;

      // Create a unique file name
      const fileExt = file.name.split('.').pop();
      const fileName = `${Math.random().toString(36).substring(2)}.${fileExt}`;
      const filePath = `${fileName}`;

      // Upload to Supabase 'media' bucket
      const { error: uploadError } = await supabase.storage
        .from('media')
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      // Get Public URL
      const { data } = supabase.storage
        .from('media')
        .getPublicUrl(filePath);

      if (data) {
        onUploadComplete(data.publicUrl);
      }
    } catch (err) {
      console.error('Upload failed:', err);
      setError(err.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="flex items-center gap-4">
        {currentImage && (
          <div className="relative w-20 h-20 bg-gray-100 rounded-lg overflow-hidden border border-gray-200">
            <img src={currentImage} alt="Preview" className="w-full h-full object-cover" />
          </div>
        )}
        
        <div className="flex-1">
          <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors">
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              {uploading ? (
                <SafeIcon icon={FiLoader} className="w-8 h-8 text-green-600 animate-spin mb-2" />
              ) : (
                <SafeIcon icon={FiUploadCloud} className="w-8 h-8 text-gray-500 mb-2" />
              )}
              <p className="mb-2 text-sm text-gray-500">
                <span className="font-semibold">{uploading ? 'Uploading...' : 'Click to upload'}</span>
              </p>
              <p className="text-xs text-gray-500">SVG, PNG, JPG or MP4</p>
            </div>
            <input 
              type="file" 
              className="hidden" 
              accept="image/*,video/*"
              onChange={handleFileChange}
              disabled={uploading}
            />
          </label>
        </div>
      </div>
      {error && <p className="text-red-500 text-xs mt-2">{error}</p>}
    </div>
  );
};

export default ImageUpload;